import { render, staticRenderFns } from "./TournamentParticipants.vue?vue&type=template&id=adb55d82&scoped=true"
import script from "./TournamentParticipants.vue?vue&type=script&lang=js"
export * from "./TournamentParticipants.vue?vue&type=script&lang=js"
import style0 from "./TournamentParticipants.vue?vue&type=style&index=0&id=adb55d82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb55d82",
  null
  
)

export default component.exports